const topics = [
  { title: '娱乐圈大瓜', desc: '明星恋情、分手、婚变等最新娱乐八卦动态', icon: 'ri-star-line', hot: true },
  { title: '网红八卦', desc: '头部网红、主播、UP主最新争议与爆料合集', icon: 'ri-live-line', hot: true },
  { title: '综艺名场面', desc: '热门综艺节目经典片段与幕后花絮盘点', icon: 'ri-tv-line', hot: false },
  { title: '国际吃瓜', desc: '海外娱乐圈、好莱坞明星最新动态汇总', icon: 'ri-global-line', hot: false },
  { title: '社会热点', desc: '全网热议的社会事件、争议话题全面跟进', icon: 'ri-fire-line', hot: true },
  { title: '经典回顾', desc: '历年经典八卦事件回顾与深度复盘分析', icon: 'ri-history-line', hot: false },
  { title: '每日快报', desc: '每日最新吃瓜资讯速递，不错过任何热点', icon: 'ri-flashlight-line', hot: false },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">瓜田导航</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            热门专题合集
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            按主题分类浏览，快速找到你感兴趣的吃瓜内容，覆盖全网热门八卦话题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href={`#cards`}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${topic.hot ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-500 group-hover:text-primary-600'}`}>
                <i className={`${topic.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-label font-medium text-foreground-900 truncate whitespace-nowrap">{topic.title}</h3>
                  {topic.hot && (
                    <span className="flex-shrink-0 text-[10px] text-primary-600 bg-primary-100 px-1.5 py-0.5 rounded whitespace-nowrap">热门</span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{topic.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}